import { initializeApp } from 'firebase/app';
import { fetchAndActivate, getRemoteConfig } from 'firebase/remote-config';

const configurations = {
  production: {
    apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
    authDomain: 'tempmeedemo.firebaseapp.com',
    databaseURL: 'https://tempmeedemo.firebaseio.com',
    projectId: 'tempmeedemo',
    storageBucket: 'tempmeedemo.appspot.com',
    messagingSenderId: '925251549185',
    appId: '1:925251549185:web:a22193c7f14317c95be800',
    measurementId: 'G-XLRGQRVNR7',
  },
  staging: {
    apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
    authDomain: 'tempmeestaging.firebaseapp.com',
    projectId: 'tempmeestaging',
    storageBucket: 'tempmeestaging.firebasestorage.app',
    messagingSenderId: '1072442773294',
    appId: '1:1072442773294:web:7faf7e29f85e5e22f9f4bf',
    measurementId: 'G-ZYKCWPCFG5',
  },
  development: {
    apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
    authDomain: 'tempmeedev.firebaseapp.com',
    databaseURL: 'https://tempmeedev.firebaseio.com',
    projectId: 'tempmeedev',
    storageBucket: 'tempmeedev.appspot.com',
    messagingSenderId: '836175226934',
    appId: '1:836175226934:web:5211ef5ffc3211bd909097',
    measurementId: 'G-QDV0ZKYKRM',
  },
};

// Get environment from process.env or default to 'development'
const environment = import.meta.env.VITE_TEMP_MEE_ENV || 'development';

// Select configuration strategy based on environment
const getFirebaseConfig = () => {
  const config = configurations[environment];

  if (!config) {
    console.warn(`Invalid VITE_TEMP_MEE_ENV: "${environment}". Falling back to development.`);
    return configurations.development;
  }

  return config;
};


const app = initializeApp(getFirebaseConfig());
const remoteConfig = getRemoteConfig(app);

// Fetch and activate Remote Config values. Await `remoteConfigReady` before
// reading a key that has no bundled default — on a cold cache (first login on
// a device) `getValue()` returns empty until this resolves.
const remoteConfigReady = fetchAndActivate(remoteConfig).catch(() => {});

export { remoteConfig, remoteConfigReady };
